"use client";
import { PostHogProvider } from "posthog-js/react";
import posthog from "posthog-js";
import { ReactNode } from "react";

interface PostHogProviderWrapperProps {
  children: ReactNode;
}

export function PostHogProviderWrapper({
  children,
}: PostHogProviderWrapperProps) {
  return (
    <PostHogProvider client={posthog}>
      {children}
    </PostHogProvider>
  );
}
